export default "__VITE_ASSET__DU1jT6OS__"